/**
 * CSS variable holding how far the page's content area starts below the top of
 * the page: the top padding, the breadcrumb/actions bar, and the gap under it.
 * A full-height centered state (e.g. the gated page) uses it as bottom padding
 * so it centers on the whole visible page rather than the area below the bar.
 */
export const PAGE_CONTENT_TOP_OFFSET_VAR = "--ig-page-content-top-offset";

/**
 * CSS variable holding the page's horizontal content padding. A full-bleed
 * element (e.g. the module empty state's backdrop) uses it to extend into that
 * padding, so anything it clips is trimmed at the page edge rather than short
 * of it.
 */
export const PAGE_CONTENT_PADDING_X_VAR = "--ig-page-content-padding-x";
